import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '../../services/modal/modal.service';

@Component({
  selector: 'app--new--modal--component--',
  template: 'NO TEMPLATE FOR ABSTRACT CLASS',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements OnDestroy {
  public isOpen = false;
  public modalId: number;

  protected componentActive: boolean = true;

  constructor(protected modalService: ModalService) {}

  public mustLockScreen() {
    return true;
  }

  public show() {
    this.modalService.showModal(this);
  }

  public close() {
    this.modalService.closeModal(this, true);
  }

  // Closes popup without doing history back
  public silentClose() {
    this.modalService.closeModal(this, false);
  }

  public toggle(opened?: boolean) {
    if (opened !== undefined) {
      if (opened && !this.isOpen) {
        this.show();
      }
      if (!opened && this.isOpen) {
        this.close();
      }
    } else {
      if (this.isOpen) {
        this.close();
      } else {
        this.show();
      }
    }
  }

  public onShow() {}

  public onClose() {}

  ngOnDestroy() {
    this.componentActive = false;
  }
}
